export default {
  init: function () {

    function calculate_quote() {

      var isValid = true;
      var total_quantity = 0;
      var total_price = 0;

      $(".tab-pane.active .list-item input").each(function () {
        var un = $(this).val();

        if (total_quantity == 0) {
          isValid = false;
        }

        if (un > 0 && un != "" && $(this).attr('data-price') != '') {
          isValid = true;
          total_quantity += parseInt(un);
          total_price = total_price + parseFloat(un * parseFloat($(this).attr('data-price')));
        }

      });

      if (isValid == false) {

        $('#calculate_price_error').show();
        $('#display_total_quantity').hide('slow');

      }
      else {

        $('#calculate_price_error').hide();

        if (total_quantity != 0 && total_price != 0) {
          $('#display_total_quantity').show('slow');
          $('#total_pieces').html(total_quantity);

          // Calculate 11% tax
          var tax = parseFloat((total_price * 11) / 100);
          total_price = total_price + tax;

          $('#esti_total_pieces').html('$' + total_price.toFixed(2));
        }

      }
    }

    function reset_quantity() { // reset quote form quantity
      $(".quote-list input").each(function () {
        $(this).val('');
      });

      $('#display_total_quantity').hide('slow');
      $('#calculate_price_error').hide('slow');
    }

    $(".quote-item input").keypress(function (e) {
      //if the letter is not digit then display error and don't type anything
      if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
        return false;
      }
    });

    $('#calculate_price_button').click(function () {
      calculate_quote();
    });

    $('#reset_price_button').click(function () {
      reset_quantity();
    });

    $(".nav-item").click(function () {
      reset_quantity();
    });

    $("button.add").click(function () {
      const val = parseInt($(this).siblings('.count-number').val());
      $(this).siblings('.count-number').val(val + 1);
      calculate_quote();
    });

    $("button.remove").click(function () {
      const val = parseInt($(this).siblings('.count-number').val());
      if (val == 0) {
        calculate_quote();
        return;
      }
      $(this).siblings('.count-number').val(val - 1);
      calculate_quote();
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/price-quote.js